/* eslint-disable import/prefer-default-export */
import {decode} from 'html-entities';
import {isArray} from './boolean';
import {dateToFormat} from './date';
import {toNumber} from './number';
import {sanitizeAddress} from './string';
import {getObjectProp} from './object';

export const getPropertyFromUrl = location => {
  const parts = [
    new URLSearchParams(location.search).get('street_1'),
    new URLSearchParams(location.search).get('street_2'),
    new URLSearchParams(location.search).get('suburb'),
    new URLSearchParams(location.search).get('city'),
    new URLSearchParams(location.search).get('postcode'),
  ];

  return {
    address: parts
      .map(part => (part && sanitizeAddress(part)) || '')
      .filter(part => !!part)
      .join(', '),
    id: null,
    images: [],
  };
};

/**
 *
 * @param {object} property
 * @returns {object}
 */
export const preparePropertyProps = property => {
  const images = getObjectProp(property, 'images') || [];
  const dateAvailable = getObjectProp(property, 'available_at');
  const dateAvailableDisplay = dateToFormat(dateAvailable);
  const rentAmount = toNumber(getObjectProp(property, 'rent_amount', 0), 0);
  const rentFrequency = getObjectProp(property, 'rental_period').trim();
  const latitude = getObjectProp(property, 'propertyFeature.latitude');
  const longitude = getObjectProp(property, 'propertyFeature.longitude');
  const city = getObjectProp(property, 'city');
  const suburb = getObjectProp(property, 'suburb');
  const postcode = getObjectProp(property, 'postcode');

  return {
    address: getObjectProp(property, 'address'),
    id: getObjectProp(property, 'id'),
    unit: getObjectProp(property, 'unit'),
    streetNumber: getObjectProp(property, 'street_number'),
    streetName: getObjectProp(property, 'street_name'),
    city,
    suburb,
    dwellingType: getObjectProp(property, 'dwelling_type'),
    thumbphoto: images.length > 0 ? images[0].thumbnail_url : undefined,
    photo: images.length > 0 ? images[0].large_url : undefined,
    bedrooms: toNumber(getObjectProp(property, 'num_bedrooms', 0)),
    bathrooms: toNumber(getObjectProp(property, 'num_bathrooms', 0)),
    parkingSpaces: toNumber(getObjectProp(property, 'num_cars', 0)),
    rentAmount,
    rentFrequency,
    status: getObjectProp(property, 'status'),
    description: decode(getObjectProp(property, 'propertyFeature.description')),
    latitude: latitude ? latitude * 1 : null,
    longitude: longitude ? longitude * 1 : null,
    addressPart1: getObjectProp(property, 'short_address'),
    addressPart2: [suburb, city, postcode].filter(Boolean).join(', '),
    postcode,
    dateAvailable,
    dateAvailableDisplay: dateAvailableDisplay || '',
    rent: ['$', rentAmount, ` ${rentFrequency}`]
      .filter((v, _, items) => {
        if (!items[1]) {
          return false;
        }
        return Boolean(v);
      })
      .join(''),
  };
};

/**
 *
 * @param {array} images
 * @returns {array}
 */
export const preparePropertyImages = images => {
  if (!isArray(images)) {
    return [];
  }
  return images.map(image => ({
    id: getObjectProp(image, 'id'),
    name: getObjectProp(image, 'nice_name'),
    src: getObjectProp(image, 'large_url'),
    thumbSrc: getObjectProp(image, 'thumbnail_url'),
  }));
};
